/**
 * onxhr-click-button
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2018 Mediatel Limited.
 */

"use strict";

export default buttonElement => {
    let executed = false;

    jQuery(document).ajaxStop(
        function () {
            if (executed === false) {
                executed = true;
                buttonElement.click();
            }
        }
    );
}